"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromotionEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _actions = require("../bet/actions");
var _types = require("../game/types");
var _types2 = require("../com/types");
var _types3 = require("../ui/types");
var _types4 = require("./types");
var _types5 = require("../blitz/types");
var _types6 = require("../autoPlay/types");
var _DialogState = require("../../../ui/enums/DialogState");
var _PromotionType = require("../../common/enums/PromotionType");
var _CommandType = require("../../dovahzul/CommandType");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PromotionEpic = exports.PromotionEpic = /*#__PURE__*/_createClass(function PromotionEpic() {
  var _this = this;
  _classCallCheck(this, PromotionEpic);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.commandFreeGameStart, _this.commandFreeGameEnd, _this.roundEndFeatureTrigger, _this.commandFreeGameStartBlitzOff);
  });
  _defineProperty(this, "roundEndFeatureTrigger", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.ROUND_END), (0, _operators.filter)(function (a) {
      return store.value.promotion.on && store.value.promotion.type === _PromotionType.PromotionType.FeatureTrigger && store.value.promotion.roundsLeft > 0;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types3.REQUEST_DIALOG_STATE,
        payload: _DialogState.DialogState.PROMOTION_NEXT
      });
    }));
  });
  _defineProperty(this, "commandFreeGameStart", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.PromotionAvailableResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      var command = a.payload;
      var fs = store.value.bet.featureSet;
      if (command.featureSet) {
        fs = command.featureSet;
      }
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types4.PROMOTION_START,
        payload: {
          promotionType: command.promotionType,
          roundsPlayed: command.roundsPlayed,
          rounds: command.rounds,
          promotionOfferId: command.promotionOfferId,
          duration: command.duration,
          durationPlayed: command.durationPlayed,
          lockedFeatureSet: command.featureSet !== undefined,
          featureType: command.featureType,
          featureTriggerId: command.featureTriggerId
        }
      }), (0, _rxjs.of)((0, _actions.updateBet)({
        lines: command.lines,
        denomination: command.denomination,
        coins: command.coins,
        featureSet: fs
      })), (0, _rxjs.of)({
        type: _types3.REQUEST_DIALOG_STATE,
        payload: _DialogState.DialogState.PROMOTION_START
      }), (0, _rxjs.of)({
        type: _types2.COMMAND_QUEUE_NEXT
      }));
    }));
  });
  /**
   * Only caches feature triggers with blitz was on. Free games allow blitz.
   * @param action$ 
   * @returns 
   */
  _defineProperty(this, "commandFreeGameStartBlitzOff", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.PromotionAvailableResponse === a.payload.type && a.payload.promotionType === _PromotionType.PromotionType.FeatureTrigger;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types5.BLITZ_MODE_OFF
      });
    }));
  });
  _defineProperty(this, "commandFreeGameEnd", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.PromotionEndResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      var command = a.payload;
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types6.AUTO_PLAY_STOP
      }), (0, _rxjs.of)({
        type: _types4.PROMOTION_END,
        payload: command
      }), (0, _rxjs.of)({
        type: _types3.REQUEST_DIALOG_STATE,
        payload: _DialogState.DialogState.PROMOTION_END
      }), (0, _rxjs.of)({
        type: _types2.COMMAND_QUEUE_NEXT
      }));
    }));
  });
});
//# sourceMappingURL=epics.js.map